<template>
  <div class="mainBox app-wrapper dream">
    <childNav :routerName="$t('audio.title')" :backFlag="true"></childNav>
    <!-- 内容 -->
    <div class="app-content config-body">
      <Row gutter="20" class="full-box">
        <i-col span="12" offset="6">
          <Form ref="project" :label-width="150" label-colon>
            <!-- 开锁提示音 -->
            <FormItem prop="name" :label="$t('audio.lock')">
              <inputBox
                input-id="lockId"
                :index="0"
                @getBinaryData="getBinaryData"
              ></inputBox>
            </FormItem>
            <!-- 呼叫提示音 -->
            <FormItem prop="description" :label="$t('audio.call')">
              <inputBox
                input-id="callId"
                :index="1"
                @getBinaryData="getBinaryData"
              ></inputBox>
            </FormItem>
            <!-- 通话提示音 -->
            <FormItem prop="areaCodeNum" :label="$t('audio.speak')">
              <inputBox
                input-id="speakId"
                :index="2"
                @getBinaryData="getBinaryData"
              ></inputBox>
            </FormItem>
            <!-- 忙提示音 -->
            <FormItem prop="name" :label="$t('audio.busy')">
              <inputBox
                input-id="busyId"
                :index="3"
                @getBinaryData="getBinaryData"
              ></inputBox>
            </FormItem>
          </Form>
          <div class="flex-box center-box">
            <Button
              type="primary"
              ghost
              class="footer-btn"
              size="large"
              @click="setNewWindow"
            >
              {{ $t("common.reset") }}
            </Button>
            <Button
              type="primary"
              class="footer-btn"
              size="large"
              @click="createFile"
            >
              {{ $t("audio.add") }}
            </Button>
          </div>
        </i-col>
      </Row>
    </div>
  </div>
</template>

<script>
import childNav from "@/components/homeNav/childNav.vue";
import inputBox from "./inputBox.vue";
import { dateFormat } from "@/utils/index";
export default {
  name: "audioPackage",
  // import引入组件等
  components: {
    childNav,
    inputBox,
  },
  props: {},
  data() {
    return {
      binaryData0: [], // 开锁提示音
      binaryData1: [], // 呼叫提示音
      binaryData2: [], // 通话提示音
      binaryData3: [], // 忙提示音
      secondArray: [1, 2, 3, 4], // 音源类型对应映射  10进制，最终转换成16进制
      firstFile: 85, // 10进制，最终转换成16进制
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    setNewWindow() {
      window.location.reload();
    },
    // 获取对应的obj，包含ArrayBuffer
    getBinaryData(val) {
      const targetObj = val;
      this["binaryData" + targetObj.index] = targetObj.binaryData; // ArrayBuffer
    },
    // 获取文件格式前索引
    getHeadMsg(binaryData, index, endAddressOfLast) {
      // endAddressOfLast:上一个文件的结束地址，int型
      const first = this.getBinaryNum(this.firstFile, 2); // 标识 固定为0x55
      const second = this.getBinaryNum(this.secondArray[index], 2); // 音源类型
      const third = this.getBinaryNum(endAddressOfLast+1, 8); // 起始地址
      const fourth = this.getBinaryNum(
        binaryData.byteLength + endAddressOfLast,
        8
      ); // 结束地址
      const targetString1 = first + "-" + second + "-" + third + "-" + fourth;
      const targetString = first + second + third + fourth;

      console.log(index + "段：：" + targetString1);
      return targetString;
    },
    // 目标数组的长度转二进制字符串
    getBinaryNum(num, bitNum) {
      let binNum = num.toString(16);
      while (binNum.length < bitNum) {
        binNum = "0" + binNum;
      }
      return binNum;
    },
    // 生成文件触发
    createFile() {
      const { binaryData0, binaryData1, binaryData2, binaryData3 } = this;
      // 完整性校验
      if (
        binaryData0.byteLength > 0 &&
        binaryData1.byteLength > 0 &&
        binaryData2.byteLength > 0 &&
        binaryData3.byteLength > 0
      ) {
        const exFileMsg0 = this.getHeadMsg(binaryData0, 0, 39); // 第一段数据
        const exFileMsg1 = this.getHeadMsg(
          binaryData1,
          1,
          39 + binaryData0.byteLength
        ); // 第2段数据
        const exFileMsg2 = this.getHeadMsg(
          binaryData2,
          2,
          39 + binaryData0.byteLength + binaryData1.byteLength 
        ); // 第3段数据
        const exFileMsg3 = this.getHeadMsg(
          binaryData3,
          3,
          39 +
            binaryData0.byteLength +
            binaryData1.byteLength +
            binaryData2.byteLength 

        ); // 第4段数据

        const exFileMsg = exFileMsg0 + exFileMsg1 + exFileMsg2 + exFileMsg3; // 全部的获取文件格式前索引
        const fileBuffer = this.mergeArrayBuffers(
          binaryData0,
          binaryData1,
          binaryData2,
          binaryData3
        ); // 具体文件的内容拼接

        this.clickToFile(exFileMsg, fileBuffer);
      } else {
        this.$message.error(this.$t("audio.tip4"));
      }
    },
    // 合并ArrayBuffers，
    mergeArrayBuffers(buffer1, buffer2, buffer3, buffer4) {
      // 创建新ArrayBuffer，计算长度
      let newBufferLength = buffer1.byteLength + buffer2.byteLength;
      if (buffer3 && buffer4) {
        newBufferLength =
          newBufferLength + buffer3.byteLength + buffer4.byteLength;

      }
      const mergedBuffer = new ArrayBuffer(newBufferLength);

      // 使用 TypedArray 视图复制原始 ArrayBuffer 的内容到新的缓冲区中
      const mergedArray = new Uint8Array(mergedBuffer);
      // 读入新的缓冲区
      mergedArray.set(new Uint8Array(buffer1), 0);
      mergedArray.set(new Uint8Array(buffer2), buffer1.byteLength);

      if (buffer3 && buffer4) {
        mergedArray.set(
          new Uint8Array(buffer3),
          buffer1.byteLength + buffer2.byteLength
        );
        mergedArray.set(
          new Uint8Array(buffer4),
          buffer1.byteLength + buffer2.byteLength + buffer3.byteLength
        );
      }
      return mergedBuffer;
    },
    // 将头部索引字符串转换为ArrayBuffer
    hexStringToArrayBuffer(hexString) {
      // hexString 16进制字符串
      hexString = hexString.replace(/^0x/i, "");
      // 如果字符串的长度是奇数，在前面添加一个 '0'
      if (hexString.length % 2 !== 0) {
        hexString = "0" + hexString;
      }
      // 创建一个Uint8Array来存储结果
      const buffer = new Uint8Array(hexString.length / 2);
      // 将每两个字符解析为一个字节，并存储在Uint8Array中
      for (let i = 0; i < hexString.length; i += 2) {
        buffer[i / 2] = parseInt(hexString.substr(i, 2), 16);
      }
      return buffer.buffer;
    },

    // 点击生成文件
    clickToFile(exFileMsg, fileBuffer) {
      const binaryString = exFileMsg;
      const dateString = dateFormat("YYYYMMDD", Date());

      const headerBuffer = this.hexStringToArrayBuffer(binaryString); // 头部索引bf
      const lastBuffer = this.mergeArrayBuffers(headerBuffer, fileBuffer); // 整体bf

      // 创建 Blob 对象
      const blob = new Blob([lastBuffer], {
        type: "application/octet-stream",
      });

      // 创建一个下载链接并模拟点击下载
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = `T-OS_FLASH_V1.00_${dateString}_Vioce.bin`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
  },
};
</script>
<style scoped lang='scss'>
.mainBox {
  width: 100%;
  height: 100%;
  background: #eef6fa;
  margin-top: 50px;
}

.config-body {
  height: 80%;
  width: 70%;
  margin: 0 auto;
  padding: 50px;
  padding-top: 100px;
  overflow: hidden;
  background: #fff;
}

.center-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}
.footer-btn{
  margin-right: 30px;
  min-width: 120px;
}

.full-box {
  width: 100%;
  height: 90%;
}

.tip-box {
  color: #fc7790;
}
</style>